import { z } from 'zod'

export const TEAM_STATUS = {
  solo: 'Hacking Solo',
  team_completed: 'In a complete team',
  join_team: 'Looking to join a team',
  more_member: 'Looking for more members',
} as const

export const CAREER_LEVEL = {
  student_level: 'Student',
  entry_level: 'Entry',
  mid_senior_level: 'Mid Senior',
  experienced_level: 'Experienced',
} as const

export const registrationFormFieldSchema = z.object({
  id: z.number(),
  name: z.string(),
  field_type: z.string(),
  required: z.boolean(),
  description: z.string(),
  registration_response: z.string(),
});

export const registrationFormSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  registration_form_fields: z.array(registrationFormFieldSchema),
});

export const participantSchema = z.object({
  id: z.number(),
  user_id: z.number(),
  username: z.string(),
  event_id: z.number(),
  avatar_url: z.string(),
  challenge_theme_id: z.string(),
  challenge_theme: z.object({
    theme: z.string(),
    description: z.string(),
    statements: z
      .array(
        z.object({
          title: z.string(),
          description: z.string(),
        })
      )
      .optional(),
  }),
  challenge_statement: z.string(),
  email: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  gender: z.enum(['female', 'male', 'non_binary', 'unspecified']),
  birthdate: z.coerce.date(),
  country_of_residence: z.string(),
  term_agreement: z.boolean(),
  career_level: z.enum([
    'student_level',
    'entry_level',
    'mid_senior_level',
    'experienced_level',
  ]),
  company_name: z.string(),
  company_email: z.string(),
  job_title: z.string(),
  team_status: z.enum(['solo', 'team_completed', 'join_team', 'more_member']),
  expertise_areas: z.array(z.string()),
  tech_stack: z.array(z.string()),
  social_network: z.string(),
  social_network_username: z.string(),
  registration_forms: z.array(registrationFormSchema),
  // Ad-attribution data. The backend uses this to find a twclid and report the
  // registration to X. Sent by BOTH registration flows, so a conversion is not
  // missed just because the registrant already had an account.
  tracking_url: z.string().optional(),
})

export type Participant = z.infer<typeof participantSchema>

export interface CustomizedParticipant {
  registration_responses_attributes: {
    registration_form_field_id: number
    response_value: string
  }[]
  // Cometly ad-attribution data, only meaningful for the guest path (it
  // creates a new StackUp account). See utils/cometly.ts.
  comet_token?: string
  tracking_url?: string
  user_agent?: string
}
